import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const ScaleBathroom: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="scale-bathroom" size={size} color={color} />
);
